import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { CycleWorkItemCollection } from '../index'

export const setupCycleWorkItemReplication = (
  collection: CycleWorkItemCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'cycleworkitems',
    displayName: 'CycleWorkItem',
    collection,
    envId,
    mapFromServer: (doc) => {
      // addedAt arrives as a Unix-ms number from the server. Coerce both candidates
      // through toTimestamp so neither NaN nor a stray ISO string can leak into the
      // number-typed required field. Fall back to Date.now() if both are unusable
      // (only possible if a malformed/legacy row sneaks through).
      const rawAddedAt = toTimestamp(doc.addedAt)
      const createdOn = toTimestamp(doc.createdOn)
      const addedAt =
        rawAddedAt && rawAddedAt > 0 ? rawAddedAt : (createdOn ?? Date.now())
      return {
        id: doc.id,
        envId: doc.envId,
        cycleId: doc.cycleId,
        workItemId: doc.workItemId,
        statusIdAtClose: doc.statusIdAtClose || null,
        progressTypeAtClose: doc.progressTypeAtClose || null,
        addedAt,
        sourceCycleId: doc.sourceCycleId ?? null,
        isDeleted: doc.isDeleted || false,
        createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
        createdBy: doc.createdBy,
        updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
        updatedBy: doc.updatedBy,
        deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
        deletedBy: doc.deletedBy,
      }
    },
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      cycleId: state.cycleId,
      workItemId: state.workItemId,
      statusIdAtClose: state.statusIdAtClose || null,
      progressTypeAtClose: state.progressTypeAtClose || null,
      // addedAt is wire-typed as long (Unix ms) — pass through as a number, NOT toISOString.
      addedAt: state.addedAt,
      sourceCycleId: state.sourceCycleId ?? null,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
